import React, { useState } from 'react';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { GraduationCap, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { ArticleDialog } from '@/components/ai/KnowledgeBase';

export const LearnButton = ({ message, ticketId, subject, suggestionId, testid = 'learn-btn' }) => {
  const [busy, setBusy] = useState(false);
  const [draft, setDraft] = useState(null);

  const learn = async () => {
    setBusy(true);
    try {
      const { data } = await api.post('/ai/learn', { message, ticket_id: ticketId, subject, suggestion_id: suggestionId });
      setDraft(data);
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  return (
    <>
      <Button size="sm" variant="outline" onClick={learn} disabled={busy || !message} data-testid={testid}>
        {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <GraduationCap className="w-4 h-4 mr-2" />}
        {busy ? 'Generalizando…' : 'Guardar como conocimiento'}
      </Button>
      <ArticleDialog open={!!draft} onOpenChange={(o) => !o && setDraft(null)} initial={draft} onSaved={() => setDraft(null)} />
    </>
  );
};
